import React, { useRef } from "react";
import emailjs from "@emailjs/browser";
import styled from "styled-components";
const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "replace with service id",
        "replace with template id",
        form.current,
        "replace with user id"
      )
      .then(
        (result) => {
          console.log(result.text);
          console.log("message sent");
        },
        (error) => {
          console.log(error.text);
        }
      );
  };

  return (
    <StyledContactForm>
      <div className='parent-div'>
        <form ref={form} onSubmit={sendEmail} className='form' >
          <label>Name</label>
          <input type="text" name="user_name"  placeholder="Enter Your Name"/>
          <label>Email</label>
          <input type="email" name="user_email" placeholder="Enter Your Email"/>
          <label>Message</label>
          <textarea name="message" placeholder="Enter Your Message"  />
          <submit  onSubmit={sendEmail} ><span>Send</span> </submit>
        </form>
      </div>
    </StyledContactForm>
  );
};

export default Contact;

// Styles
const StyledContactForm = styled.div`
  width: 75%;
  display:block;
  margin:0 auto;
  margin-top:100px;

  form {
   
    display: flex;
    align-items:center;
    justify-content:center;
    flex-direction: column;
    width: 100%;
    font-size: 16px;

    input {
      width: 100%;
      height: 35px;
      padding: 7px;
      outline: none;
      border-radius: 5px;
      border: 1px solid black;

      &:focus {
        border:2px solid #354259;

      }
    }

    textarea {
      max-width: 100%;
      min-width: 100%;
      width: 100%;
      max-height: 100px;
      min-height: 100px;
      padding: 7px;
      outline: none;
      border-radius: 5px;
      border: 1px solid black;

      &:focus {
        border:2px solid #354259;

      }
    }

    label {
      margin-top: 1rem;
    }

   submit {
      margin-top: 2rem;
      cursor: pointer;
      color: #354259;
      font-weight:bold;
      border: 2px solid #354259;
      transition: all 0.7s;
      height:40px;
      width:150px;
      border-radius: 10px;
      text-align: center;
    }
    submit span{
      position:relative;
      top:5.5px;
    }
   submit:hover {
    background:#354259;
    color:white;
    transition: all 0.7s;
    }


  }
`;